angular.module('TetherApp').factory('sweepstakesTemplateService', [
    '$location',
    'templateService',
    function ($location, templateService) {

        let title = ($location.absUrl().indexOf('create') > -1) ? 'Create' : 'Edit';

        let form = {
            title: title + ' Sweepstakes',
            divs: [
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'name',
                        class: 'form-control',
                        placeholder: 'Experience Name',
                        label: {
                            for: 'name',
                            class: 'form-control',
                            value: 'Experience Name'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'title',
                        class: 'form-control',
                        placeholder: 'Title',
                        label: {
                            for: 'title',
                            class: 'form-control',
                            value: 'Title'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'domain',
                        class: 'form-control',
                        placeholder: 'Domain',
                        label: {
                            for: 'domain',
                            class: 'form-control',
                            value: 'Domain'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('select'),
                    attributes: {
                        name: 'prize_method_class',
                        class: 'form-control',
                        label: {
                            for: 'prize_method_class',
                            class: 'form-control',
                            value: 'Choose your prizing method:'
                        },
                        options: [
                            {
                                value: 'sweepstakes.keyword',
                                text: 'Keyword'
                            },
                            {
                                value: 'sweepstakes.lottery',
                                text: 'Lottery'
                            }
                        ],
                        selectedValue: {
                            value: 'sweepstakes.keyword',
                            text: 'Keyword'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('checkbox'),
                    attributes: {
                        name: 'has_sharing',
                        class: 'form-control',
                        placeholder: 'Has Sharing',
                        input: 1,
                        value: 1,
                        label: {
                            for: 'has_sharing',
                            class: 'form-control',
                            value: 'Has Sharing'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'skill_testing_question_answer',
                        class: 'form-control',
                        placeholder: 'Skill Testing Question Answer',
                        label: {
                            for: 'skill_testing_question_answer',
                            class: 'form-control',
                            value: 'Skill Testing Question Answer'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('checkbox'),
                    attributes: {
                        name: 'has_language_gate',
                        class: 'form-control',
                        placeholder: 'Has Language Gate',
                        value: 1,
                        label: {
                            for: 'has_language_gate',
                            class: 'form-control',
                            value: 'Has Language Gate'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('checkbox'),
                    attributes: {
                        name: 'has_separate_optin_message',
                        class: 'form-control',
                        placeholder: 'Has Separate Optin Message',
                        value: 1,
                        label: {
                            for: 'has_separate_optin_message',
                            class: 'form-control',
                            value: 'Has Separate Optin Message'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('checkbox'),
                    attributes: {
                        name: 'has_optin',
                        class: 'form-control',
                        placeholder: 'Has Optin',
                        value: 1,
                        label: {
                            for: 'has_optin',
                            class: 'form-control',
                            value: 'Has Optin'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'rate_limit_sms',
                        class: 'form-control',
                        placeholder: 'Rate Limit Sms',
                        label: {
                            for: 'rate_limit_sms',
                            class: 'form-control',
                            value: 'Rate Limit Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'link_sms',
                        class: 'form-control',
                        placeholder: 'Link Sms',
                        label: {
                            for: 'link_sms',
                            class: 'form-control',
                            value: 'Link Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'invalid_keyword_sms',
                        class: 'form-control',
                        placeholder: 'Invalid Keyword Sms',
                        label: {
                            for: 'invalid_keyword_sms',
                            class: 'form-control',
                            value: 'Invalid Keyword Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'optin_prompt_sms',
                        class: 'form-control',
                        placeholder: 'Optin Prompt Sms',
                        label: {
                            for: 'optin_prompt_sms',
                            class: 'form-control',
                            value: 'Optin Prompt Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'optin_welcome_sms',
                        class: 'form-control',
                        placeholder: 'Optin Welcome Sms',
                        label: {
                            for: 'optin_welcome_sms',
                            class: 'form-control',
                            value: 'Optin Welcome Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'optout_sms',
                        class: 'form-control',
                        placeholder: 'Optout Sms',
                        label: {
                            for: 'optout_sms',
                            class: 'form-control',
                            value: 'Optout Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'already_opted_in_sms',
                        class: 'form-control',
                        placeholder: 'Already Opted in Sms',
                        label: {
                            for: 'already_opted_in_sms',
                            class: 'form-control',
                            value: 'Already Opted in Sms'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'rate_limit_sms_fr',
                        class: 'form-control',
                        placeholder: 'Rate Limit Sms FR',
                        label: {
                            for: 'rate_limit_sms_fr',
                            class: 'form-control',
                            value: 'Rate Limit Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'link_sms_fr',
                        class: 'form-control',
                        placeholder: 'Link Sms FR',
                        label: {
                            for: 'link_sms_fr',
                            class: 'form-control',
                            value: 'Link Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'invalid_keyword_sms_fr',
                        class: 'form-control',
                        placeholder: 'Invalid Keyword Sms FR',
                        label: {
                            for: 'invalid_keyword_sms_fr',
                            class: 'form-control',
                            value: 'Invalid Keyword Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'optin_prompt_sms_fr',
                        class: 'form-control',
                        placeholder: 'Optin Prompt Sms FR',
                        label: {
                            for: 'optin_prompt_sms_fr',
                            class: 'form-control',
                            value: 'Optin Prompt Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'optin_welcome_sms_fr',
                        class: 'form-control',
                        placeholder: 'Optin Welcome Sms FR',
                        label: {
                            for: 'optin_welcome_sms_fr',
                            class: 'form-control',
                            value: 'Optin Welcome Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'optout_sms_fr',
                        class: 'form-control',
                        placeholder: 'Optin Sms FR',
                        label: {
                            for: 'optout_sms_fr',
                            class: 'form-control',
                            value: 'Optin Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'already_opted_in_sms_fr',
                        class: 'form-control',
                        placeholder: 'Already Opted in Sms FR',
                        label: {
                            for: 'already_opted_in_sms_fr',
                            class: 'form-control',
                            value: 'Already Opted in Sms FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('sweepstakesStartedAt'),
                    attributes: {
                        name: 'started_at',
                        class: 'form-control',
                        placeholder: 'Started At',
                        label: {
                            for: 'started_at',
                            class: 'form-control',
                            value: 'Started At'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('sweepstakesEndedAt'),
                    attributes: {
                        name: 'ended_at',
                        class: 'form-control',
                        placeholder: 'Ended At',
                        label: {
                            for: 'ended_at',
                            class: 'form-control',
                            value: 'Ended At'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'title_fr',
                        class: 'form-control',
                        placeholder: 'Title FR',
                        label: {
                            for: 'title_fr',
                            class: 'form-control',
                            value: 'Title FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'landing_page_html',
                        class: 'form-control',
                        placeholder: 'Landing Page HTML',
                        label: {
                            for: 'landing_page_html',
                            class: 'form-control',
                            value: 'Landing Page HTML'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'landing_page_html_fr',
                        class: 'form-control',
                        placeholder: 'Landing Page HTML FR',
                        label: {
                            for: 'landing_page_html_fr',
                            class: 'form-control',
                            value: 'Landing Page HTML FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'sorry_page_html',
                        class: 'form-control',
                        placeholder: 'Sorry Page HTML',
                        label: {
                            for: 'sorry_page_html',
                            class: 'form-control',
                            value: 'Sorry Page HTML'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'sorry_page_html_fr',
                        class: 'form-control',
                        placeholder: 'Sorry Page HTML FR',
                        label: {
                            for: 'sorry_page_html_fr',
                            class: 'form-control',
                            value: 'Sorry Page HTML FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'twitter_message',
                        class: 'form-control',
                        placeholder: 'Twitter Message',
                        label: {
                            for: 'twitter_message',
                            class: 'form-control',
                            value: 'Twitter Message'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'twitter_message_fr',
                        class: 'form-control',
                        placeholder: 'Twitter Message FR',
                        label: {
                            for: 'twitter_message_fr',
                            class: 'form-control',
                            value: 'Twitter Message FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'terms_html',
                        class: 'form-control',
                        placeholder: 'Terms HTML',
                        label: {
                            for: 'terms_html',
                            class: 'form-control',
                            value: 'Terms HTML'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'privacy_html',
                        class: 'form-control',
                        placeholder: 'Privacy HTML',
                        label: {
                            for: 'privacy_html',
                            class: 'form-control',
                            value: 'Privacy HTML'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'terms_html_fr',
                        class: 'form-control',
                        placeholder: 'Terms HTML FR',
                        label: {
                            for: 'terms_html_fr',
                            class: 'form-control',
                            value: 'Terms HTML FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'privacy_html_fr',
                        class: 'form-control',
                        placeholder: 'Privacy HTML FR',
                        label: {
                            for: 'privacy_html_fr',
                            class: 'form-control',
                            value: 'Privacy HTML FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'meta_html',
                        class: 'form-control',
                        placeholder: 'Meta HTML',
                        label: {
                            for: 'meta_html',
                            class: 'form-control',
                            value: 'Meta HTML'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('textarea'),
                    attributes: {
                        name: 'meta_html_fr',
                        class: 'form-control',
                        placeholder: 'Meta HTML FR',
                        label: {
                            for: 'meta_html_fr',
                            class: 'form-control',
                            value: 'Meta HTML FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'domain_fr',
                        class: 'form-control',
                        placeholder: 'Domain FR',
                        label: {
                            for: 'domain_fr',
                            class: 'form-control',
                            value: 'Domain FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'contest_over_sms',
                        class: 'form-control',
                        placeholder: 'Contest Over SMS',
                        label: {
                            for: 'contest_over_sms',
                            class: 'form-control',
                            value: 'Contest Over SMS'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'contest_over_sms_fr',
                        class: 'form-control',
                        placeholder: 'Contest Over SMS FR',
                        label: {
                            for: 'contest_over_sms_fr',
                            class: 'form-control',
                            value: 'Contest Over SMS FR'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'asset_prefix',
                        class: 'form-control',
                        placeholder: 'Asset Prefix',
                        label: {
                            for: 'asset_prefix',
                            class: 'form-control',
                            value: 'Asset Prefix'
                        }
                    }
                },
                {
                    templateUrl: templateService.getTemplateUrl('text'),
                    attributes: {
                        name: 'ga_code',
                        class: 'form-control',
                        placeholder: 'Google Analytics Code',
                        label: {
                            for: 'ga_code',
                            class: 'form-control',
                            value: 'Google Analytics Code'
                        }
                    }
                }
            ]
        };

        return {
            form: form
        }

    }
]);
